export const userProfileImageLimits = {
  // 2 MB (2 * 1024 * 1024 bytes)
  MAX_BYTES: 2 * 1024 * 1024,
  PHOTO_SIZE_PX: 100,
};

export const userProfileLabels = {
  DELETE_IMAGE_MESSAGE: "Are you sure you want to delete Image?",
};
